import React from "react";
import Image from "../../../../Image";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";

const VerticalStepper = (props) => {
  const steps = [
    {
      name: "investor-details",
      value: "Investor Details",
      image: "/images/home.png",
      url: "/new-investor-transaction/investor-details",
      data: !!props.applicantparams.i_dob,
    },
    {
      name: "fatca-details",
      value: "FATCA Details",
      image: "/images/ekyc.svg",
      url: "/new-investor-transaction/fatca-details",
      data: !!props.fatcaDetails.i_invpin,
    },
    {
      name: "nominee-details",
      value: "Nominee Details",
      image: "/images/investor.png",
      url: "/new-investor-transaction/nominee-details",
      data: !!props?.nomineDetails?.payload?.IWishToNominate,
    },
    {
      name: "bank-details",
      value: "Bank Details",
      image: "/images/newtransaction.png",
      url: "/new-investor-transaction/bank-details",
    },
    {
      name: "scheme-details",
      value: "Scheme Details",
      image: "/images/connect.png",
      url: "new-investor-transaction/scheme-details",
    },
  ];
  const { active, hide } = props;
  const { state } = useLocation();
  return (
    <div className="vertical-stepper-body-new-investor-flow">
      {!hide && (
        <div className="vertical-stepper-body-new-investor-flow">
          {steps.map((step, index) => (
            <Link
              to={(location) => ({
                ...location,
                pathname: step.url,
              })}
            >
              <div className="d-flex" key={index} style={{ marginRight: 12 }}>
                <div
                  style={{
                    border: "1px solid ",
                    borderColor: step.name === active ? "#003D78" : "gray",
                    height: "40px",
                    width: "40px",
                    borderRadius: "20px",
                    margin: "0px 15px 10px 0px",
                  }}
                >
                  <Image
                    src={step.image}
                    alt="nav"
                    style={{
                      height: "20px",
                      marginTop: "8px",
                      marginLeft: "10px",
                    }}
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ marginRight: "10px" }}
                >
                  <span
                    style={{ color: "gray", fontWeight: 500, fontSize: "12px" }}
                  >
                    Step {index + 1}
                  </span>
                  <span
                    style={{
                      color: step.name === active ? "#003D78" : "gray",
                      fontWeight: 600,
                    }}
                  >
                    {step.value}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
export default connect(({ newinvestor }) => {
  const {
    applicantparams,
    schemeDetails,
    fatcaDetails,
    investmentparams,
    nomineDetails,
  } = newinvestor;
  return {
    applicantparams,
    schemeDetails,
    fatcaDetails,
    applicantparams,
    investmentparams,
    nomineDetails,
  };
})(VerticalStepper);
